import { Modal, Typography } from 'antd';
import * as React from 'react';
import ReactJson from 'react-json-view';

const { Text } = Typography;

type Props = {
    visible: boolean;
    onClose: () => void;
    packageName: string;
    jsonDiff: unknown;
};

const JsonDiffDialog: React.FC<Props> = ({ visible, onClose, packageName, jsonDiff }) => {
    return (
        <Modal
            title={
                <div>
                    <Text strong>JSON Schema Differences</Text>
                    <div style={{ marginTop: 4 }}>
                        <Text type="secondary">Package: {packageName}</Text>
                    </div>
                </div>
            }
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={800}
            destroyOnClose
        >
            <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
                {jsonDiff ? (
                    <ReactJson
                        src={jsonDiff as object}
                        displayDataTypes={false}
                        enableClipboard={false}
                        collapsed={1}
                        theme="rjv-default"
                    />
                ) : (
                    <Text type="secondary">No differences found for this package.</Text>
                )}
            </div>
        </Modal>
    );
};

export default JsonDiffDialog;
